import Plan from '../../classes/plan';
import { IPlanState } from '../../types/interfaces/states';
import { RootState } from '../store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: IPlanState = {
  data: [],
};

const plansSlice = createSlice({
  name: 'plans',
  initialState,
  reducers: {
    setAnonymous: (state, action: PayloadAction<Plan | undefined>) => {
      state.anonymous = action.payload;
    },
    setPlans: (state, action: PayloadAction<Plan[]>) => {
      state.data = action.payload;
    },
  },
});

const { actions, reducer: plansReducer } = plansSlice;
export const { setAnonymous, setPlans } = actions;
export const planSelector = (state: RootState) => state.plans;
export default plansReducer;
